import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";
import React from "react";
import PopupDialog from "../../Form/PopupDialog";
import { Dialog } from "./DialogProvider";

interface Props {
    title: string;
    question: string;
    hint?: string;
    acceptButtonTitle?: string;
    cancelButtonTitle?: string;
    testId?: string;
}

const useStyles = makeStyles({
    question: {
        marginBottom: "1rem"
    },
    hint: {
        color: "rgba(0, 0, 0, 0.60)"
    }
});

const ConfirmationDialog: Dialog<void, Props> = props => {
    const classes = useStyles();

    const {
        onCancel,
        onAccept,
        title,
        hint,
        question,
        acceptButtonTitle,
        cancelButtonTitle
    } = props;

    return (
        <PopupDialog
            testId="ConfirmationDialog-PopupDialog"
            open
            onSecond={onCancel}
            onFirst={onAccept}
            firstTitle={acceptButtonTitle ?? "Bestätigen"}
            secondTitle={cancelButtonTitle ?? "Abbrechen"}
            title={title}>

            <Typography
                variant="body1"
                className={classes.question}>
                {question}
            </Typography>

            {hint && (
                <Typography
                    variant="body2"
                    className={classes.hint}>
                    {hint}
                </Typography>
            )}

        </PopupDialog>
    );
};

export default ConfirmationDialog;
